<!--
* 组件名 : 序言首页、结语组件
* 开发者 : JY
*
* 参数:
*  data   { Object }   required - 首页数据
*  bg     { String }   required - 背景
*  name   { String }   required - 章节名称
*
* 事件:  null
*
-->

<template>
  <div class="v-preface-conclusion">
    <v-background :src="bg" />
    <div class="content-box" ref="contentBox" v-slide-up-in-stage="0">
      <h1 class="title1">{{ name }}</h1>
      <div class="content-info set-font-size" v-html="data.content" />
    </div>

    <v-fade-out-in
      class="canvas-mask"
      v-if="isShow"
      :img="bgSrc"
      :bot-area="0.7"
    />
  </div>
</template>

<script>
import { i18n } from "utils/util";

export default {
  name: "v-preface-conclusion",
  computed: {
    bgSrc() {
      return i18n(this.bg);
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    bg: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isShow: false,
    };
  },

  mounted() {
    this.is_show_canvas();
  },
  methods: {
    /**
     * 判断是否需要显示 canvas 遮罩层
     */
    is_show_canvas() {
      let H = this.$refs.contentBox.scrollHeight;
      this.isShow = window.innerHeight > H - 10 ? false : true;
    },
    /**
     * 控制序言部分内容超出一屏时滚动隐藏canvas
     */
    on_parallax_pined_top(payload) {
      $(".canvas-mask").removeClass("d-none");
    },
    on_parallax_un_pin(payload) {
      $(".canvas-mask").addClass("d-none");
    },
  },
};
</script>

<style lang="scss">
.v-preface-conclusion {
  width: 100%;
  position: relative;

  .content-box {
    min-height: 100vh;
    margin: auto;
    padding: {
      top: 110px;
      bottom: 120px;
    }

    h1,
    p,
    strong,
    span,
    i {
      color: $color-white;
    }

    h1 {
      font: {
        size: 44px;
      }
    }

    .content-info {
      padding-top: 48px;
      padding-bottom: 0;

      p {
        margin-bottom: 24px;
        font-size: var(--font-size);
        line-height: 1.8;
      }
    }
  }

  .v-fade-out-in {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: $lx-min) {
    .content-box {
      h1 {
        font-size: 30px;
      }

      .content-info {
        padding-top: 32px;
      }
    }
  }
}

.conclusion-wrap {
  .v-preface-conclusion {
    .content-box {
      padding-bottom: 360px;
    }
  }
}

body[data-lang="zh-TW"],
body[data-lang="zh-CN"] {
  .v-preface-conclusion {
    .content-box {
      position: relative;
      z-index: 1;

      p {
        text-indent: 2em;
      }
    }
  }

  .introduction-wrap {
    .v-preface-conclusion {
      .content-box {
        h1 {
          letter-spacing: 1em;
        }
      }
    }
  }
}

body.latin {
  @media (min-width: $lx-min) {
    .v-preface-conclusion {
      .content-box h1 {
        font-size: 34px;
        font-family: Georgia;
      }
    }
  }

  &[data-slug="introduction"] {
    .v-preface-conclusion {
      .content-info {
        padding-bottom: 100px;
      }
    }
  }
}
</style>
